import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "21",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#09262D",
  stroke: "#09262D",
  "stroke-width": ".543",
  d: "m18.312 16.52 4.863-6.877a5.675 5.675 0 0 0-.832-6.955 5.686 5.686 0 0 0-8.036 0 5.646 5.646 0 0 0-.832 6.955l.026.025zm4.006-7.433-4.006 5.67-4.005-5.67a4.656 4.656 0 0 1 .705-5.719c1.814-1.813 4.787-1.813 6.627 0a4.69 4.69 0 0 1 .679 5.72Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#09262D",
  stroke: "#09262D",
  "stroke-width": ".543",
  d: "M18.413 9.163a2.31 2.31 0 0 0 2.317-2.317 2.31 2.31 0 0 0-2.317-2.318 2.31 2.31 0 0 0-2.318 2.318 2.33 2.33 0 0 0 2.318 2.317Zm0-3.653c.73 0 1.31.58 1.31 1.31s-.58 1.31-1.31 1.31-1.31-.58-1.31-1.31c0-.705.58-1.31 1.31-1.31ZM6.723 16.52l4.837-6.853-.831-.58-4.031 5.695-4.006-5.669a4.656 4.656 0 0 1 .706-5.719c1.814-1.814 4.787-1.814 6.626 0l.73-.731a5.686 5.686 0 0 0-8.036 0 5.646 5.646 0 0 0-.832 6.954l.026.026z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#09262D",
  stroke: "#09262D",
  "stroke-width": ".543",
  d: "M6.823 9.163A2.31 2.31 0 0 0 9.14 6.846a2.31 2.31 0 0 0-2.318-2.318 2.31 2.31 0 0 0-2.318 2.318 2.33 2.33 0 0 0 2.318 2.317Zm0-3.653c.73 0 1.31.58 1.31 1.31s-.58 1.31-1.31 1.31-1.31-.58-1.31-1.31c0-.705.58-1.31 1.31-1.31ZM18.565 19.997a.743.743 0 0 0 .755-.755.743.743 0 0 0-.756-.756.743.743 0 0 0-.755.756c0 .428.327.755.755.755Zm0-1.007c.151 0 .251.1.251.252 0 .151-.1.252-.252.252-.151 0-.252-.1-.252-.252 0-.151.1-.252.252-.252ZM15.541 19.997a.743.743 0 0 0 .756-.755.743.743 0 0 0-.756-.756.743.743 0 0 0-.756.756c0 .428.328.755.756.755Zm0-1.007c.152 0 .252.1.252.252 0 .151-.1.252-.252.252s-.252-.1-.252-.252c0-.151.1-.252.252-.252ZM12.518 19.997a.743.743 0 0 0 .755-.755.743.743 0 0 0-.755-.756.743.743 0 0 0-.756.756c0 .428.327.755.756.755Zm0-1.007c.151 0 .252.1.252.252 0 .151-.1.252-.252.252s-.252-.1-.252-.252c0-.151.1-.252.252-.252ZM9.494 19.997a.743.743 0 0 0 .756-.755.743.743 0 0 0-.756-.756.743.743 0 0 0-.756.756c0 .428.328.755.756.755Zm0-1.007c.152 0 .252.1.252.252 0 .151-.1.252-.252.252-.151 0-.252-.1-.252-.252 0-.151.1-.252.252-.252ZM6.47 19.997a.743.743 0 0 0 .757-.755.743.743 0 0 0-.756-.756.743.743 0 0 0-.756.756c0 .428.328.755.756.755Zm0-1.007c.152 0 .253.1.253.252 0 .151-.1.252-.252.252s-.252-.1-.252-.252c0-.151.1-.252.252-.252Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }